import Info from './Info';
import { IInfo } from './Info.interfaces';

export default Info;
export { Info, IInfo };
